import {Component, effect, inject} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

type LoaderElementData = {
  labelKey: string;
  loading: (...args: any) => boolean; //enables signal usage
  error?: (...args: any) => string|undefined; //enables signal usage
}

@Component({
  selector: 'app-loader-element',
  imports: [
    TranslatePipe
  ],
  templateUrl: './loader-element.component.html',
  styleUrl: './loader-element.component.scss'
})
export class LoaderElementComponent {
  dialogRef = inject(MatDialogRef<LoaderElementComponent>, {optional: true});
  data = inject(MAT_DIALOG_DATA, {optional: true}) as LoaderElementData || {
    labelKey: "GLOBAL.LOADING",
    loading: () => true,
  } as LoaderElementData;

  constructor() {
    effect(() => { !this.data.loading() && this.dialogRef?.close() });
  }

}
